import { render, staticRenderFns } from "./ExamForm.vue?vue&type=template&id=4ca85bb0&scoped=true&"
import script from "./ExamForm.vue?vue&type=script&lang=js&"
export * from "./ExamForm.vue?vue&type=script&lang=js&"
import style0 from "./ExamForm.vue?vue&type=style&index=0&id=4ca85bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca85bb0",
  null
  
)

export default component.exports